import React from 'react';

function Logo(props) {

    return ( 
        <div style={{
                        border:"2px dotted white",
                        padding:"5px",
                        margin:"5px",
                        borderRadius:"10px"

        }}>
            <h1>Logo component: {props.company}</h1>
           <img src={require("../assets/" + props.company + ".png")} alt="" />
        </div>
     );
}

export default Logo;